<button mat-flat-button [disabled]="disabled" (click)="acaoClick()" class="center-center"
        [style.background-color]="backgroundColor ?? 'var(--primary)'" [style.color]="color ?? 'var(--primary-text)'"
        [style.width]="width ?? '35px'" [style.height]="height ?? '35px'" [style.min-width]="width ?? '35px'"
        [style.min-height]="height ?? '35px'"
        [style.border-color]="borderColor ?? 'var(--secundary)'" [style.border-radius]="borderRadius ?? ''"
        [style.box-shadow]="boxShadow ?? ''"
        [style.border-style]="borderStyle ?? 'none'"
        [style.border-right-style]="borderStyle ? borderStyle : borderRightStyle ? borderRightStyle : 'none'"
        [style.border-width]="borderWidth ?? '0'"
        [style.border-right-width]="borderWidth ? borderWidth : borderRightWidth ? borderRightWidth : '0'"
        [style.padding]="padding"
        [type]="type"
>
  @if (label) {
    <span [style.font-size]="fontSize ?? '16px'" [style.letter-spacing]="letterSpacing ?? ''"
          [style.font-weight]="fontWeight ?? '500'">{{ label }}</span>
  } @else if (icon) {
    <mat-icon class="center-center" [ngClass]="classIcon ?? ''" style="margin: 0" [style.width]="widthIcon ?? 'auto'"
              [style.height]="heightIcon ?? 'auto'" [style.font-size]="fontSize ?? '16px'">{{ icon }}
    </mat-icon>
  } @else if (iconSrc) {
    <img [src]="'./assets/' + iconSrc + iconSrcExtensao" alt="" [style.width]="widthIcon ?? '27px'"
         [style.height]="heightIcon ?? '27px'"/>
  }
</button>
